/* eslint-disable import/prefer-default-export */
/**
 * Formats a value for display in chart axes and tooltips.
 * @param {number|string} value
 * @param {"number"|"percentage"|"duration"|"datetime"|"string"|undefined} valueType
 * @returns {string}
 */
export function formatValue(value, valueType) {
    if (value === null || value === undefined) return "";

    switch (valueType) {
        case "percentage":
            return `${Number(value).toFixed(1)}%`;
        case "duration": {
            const totalSeconds = Number(value);
            if (Number.isNaN(totalSeconds)) return String(value);
            const h = Math.floor(totalSeconds / 3600);
            const m = Math.floor((totalSeconds % 3600) / 60);
            if (h > 0) return `${h}h ${m}m`;
            return `${m}m`;
        }
        case "datetime":
            return String(value);
        case "number":
        default:
            if (typeof value === "number") {
                return value >= 1000 ? `${(value / 1000).toFixed(1)}k` : String(value);
            }
            return String(value);
    }
}
